export default __webpack_public_path__ + "static/media/Ellipse3.49f2d3c4.svg";